import { render, staticRenderFns } from "./edit-index-content.vue?vue&type=template&id=027d559e&scoped=true"
import script from "./edit-index-content.vue?vue&type=script&lang=js"
export * from "./edit-index-content.vue?vue&type=script&lang=js"
import style0 from "./edit-index-content.vue?vue&type=style&index=0&id=027d559e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "027d559e",
  null
  
)

export default component.exports